import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { Link, useNavigate } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Own_vehicle_closed_list = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("branch") || "");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

   const canView  = hasPermission("Closed Vehicle List", "view");

  // Fetch branches only once
  useEffect(() => {
    axios.get("https://rfs2.infraconsoft.net.in/api/own_vehicle_closed_list")
      .then((response) => {
        setBranches(response.data.branches);
      })
      .catch((error) => {
        console.error("Error fetching branches:", error);
      });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/own_vehicle_closed_list?branch_code=${selectedBranch}`
        );
        setData(response.data.vehicles);
        setFilteredData(response.data.vehicles);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
      } finally {
        setLoading(false);
      }
    };

    if (selectedBranch) {
      fetchData();
    }
  }, [selectedBranch]);


  // Handle page change
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate indexes for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle search filter
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    const filtered = data.filter((item) => {
      return (
        item.vehicle_name.toLowerCase().includes(e.target.value.toLowerCase()) ||
        item.vehicle_number.toLowerCase().includes(e.target.value.toLowerCase()) ||
        item.vehicle_type.toLowerCase().includes(e.target.value.toLowerCase())
      );
    });
    setFilteredData(filtered);
    setCurrentPage(1); // Reset to first page on search
  };

  const handleSelection = (event) => {
    const value = event.target.value;
    if (value) {
      navigate('/hire_vehicle_closed_list');
    }
  };

  if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }



  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Own Vehicle-Closed List</h2>
          <div>
            <Time />
          </div>
        </section>


     <div className="vehicle-class">
  <div>
    <p>Branch wise Report :</p>
<select 
            value={selectedBranch} 
            onChange={(e) => setSelectedBranch(e.target.value)} 
            required 
            className="branch-select"
          >
            <option value="">Select Branch</option>
            {branches.map((item) => (
              <option key={item.branchMaster_code} value={item.branchMaster_code}>
                {item.branchMaster_name}
              </option>
            ))}
          </select>
  </div>

  <div>
    <p>Select your vehicle:</p>
    <select className="branch-select" onChange={handleSelection}>     
        <option value="/own">Own Vehicle</option>   
            <option value="/hire">Hire Vehicle</option>  
    </select>
  </div>
</div>
        
        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input type="text" placeholder="Search by vehicleName" value={searchTerm} onChange={handleSearch} className="search-input" />
        </div>

        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Vehicle Code</th>
                <th>Vehicle Number</th>
                <th>Vehicle Name</th>
                <th>Vehicle Type</th>
                <th>Vehicle Company Name</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
                          {loading ? (
                            <tr>
                              <td colSpan="6" className="loading-text">
                                Loading data, please wait...
                              </td>
                            </tr>
                          ) : currentData.length > 0 ? (
                            currentData.map((item, index) => (
                              <tr key={index}>
                              <td>{indexOfFirstItem + index + 1}</td>
                              <td>{item.vehicle_code}</td>
                              <td>{item.vehicle_number}</td>
                              <td>{item.vehicle_name}</td>
                              <td>{item.vehicle_type}</td>
                              <td>{item.vehicle_purfrom}</td>
                              {/* <td>
                                <Link to={`/vehicle_details_view/${item.SlNo}`}>View</Link>
                              </td> */}

                              <td>
                                <Link to={`/vehicle_closed_view/${item.SlNo}`}>View</Link>
                              </td>
                            </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6">No Data Available</td>
                            </tr>
                          )}
                        </tbody>

                    </table>
        </div>

        {/* Pagination Controls */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Own_vehicle_closed_list;
